import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { Validators, FormControl } from '@angular/forms';

@Component({
  selector: 'app-autorizador',
  templateUrl: './autorizador.component.html',
  styleUrls: ['./autorizador.component.scss']
})
export class AutorizadorDialog {
  hide: boolean;

  contrasenaFormControl = new FormControl('', [
    Validators.required
  ]);

  constructor(
    public dialogAutorizar: MatDialogRef<AutorizadorDialog>
  ) { }

  onCancelar(): void {
    this.dialogAutorizar.close();
  }

  onAceptar(): void {
    if (this.contrasenaFormControl.hasError('required')) {
      this.contrasenaFormControl.markAsTouched();
    } else {
      this.dialogAutorizar.close(this.contrasenaFormControl.value);
    }
  }
}